exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-group-wrapper{display:inline-block}.c-group-wrapper>button{margin-right:15px}.c-group-wrapper>button:last-child{margin-right:0}.c-group-wrapper_right{display:flex;flex:1;justify-content:flex-end}.c-group-wrapper_right>button{margin-left:15px;margin-right:0}.c-group-wrapper_right>button:first-child{margin-left:0;margin-right:0}", ""]);

// exports
